import React, { Component } from 'react'
import {
  Form,
  Select,
  Button,
  Modal,
  notification,
  Spin,
  Card,
  Alert,
} from 'antd'
import _ from 'lodash'
import AppHelper from 'libs/AppHelper'
import { API_HOST } from '../../configs/env'
import whttp from '../../libs/whttp'
import { __ } from '@wordpress/i18n'
import styles from './styles.module.scss'

const VC_CONFIG = _.get(window, 'VC_CONFIG', {})
const { Option } = Select

/**
 * 大平台載具綁定頁面
 * 用戶登入後選擇會員卡進行載具綁定
 */
export default class UserCarrierBinding extends Component {
  state = {
    isLoading: true,
    isSubmitting: false,
    cardOptions: [],
    selectedCard: '',
    cardType: null,
    memberInfo: null,
    bigPlatformToken: null,
    bigPlatformBan: null,
  }

  componentDidMount() {
    // 檢查是否從大平台流程進入
    const token = AppHelper.getLocalStorage('big-platform-token')
    const ban = AppHelper.getLocalStorage('big-platform-ban')

    // 進入頁面後即清除導向標記，避免下次登入重複導向
    AppHelper.removeLocalStorage('from-big-platform')

    console.log('載具綁定頁面初始化:', { token, ban })

    if (!token || !ban) {
      return this.showErrorAndRedirect(
        __('無效的載具歸戶請求', 'cec-plugin-stores')
      )
    }

    this.setState(
      {
        bigPlatformToken: token,
        bigPlatformBan: ban,
      },
      () => {
        // 載入會員資料和卡片清單
        this.loadMemberInfo()
        this.loadCards()
      }
    )
  }

  /**
   * 載入會員資料
   */
  loadMemberInfo = () => {
    whttp.get(API_HOST + `/api/account/cc/getProfiles`, {}, (state, res) => {
      const { code = 100, reason = '發生錯誤', data = {} } = res

      if (state === false || code !== 200) {
        console.error('載入會員資料失敗:', reason)
        return
      }

      console.log('會員資料:', data)

      this.setState({
        memberInfo: data,
      })
    })
  }

  /**
   * 載入會員卡清單
   */
  loadCards = () => {
    this.setState({ isLoading: true })

    whttp.get(
      API_HOST + '/api/account/oca/getCCEInvoiceCarrierList',
      {},
      (state, res) => {
        const { code = 100, reason = '發生錯誤', data = {} } = res

        console.log('會員卡清單:', { state, code, data })

        this.setState({ isLoading: false })

        if (state === false || code !== 200) {
          return Modal.error({
            title: __('載入失敗', 'cec-plugin-stores'),
            content: reason,
          })
        }

        this.setState({
          cardOptions: data || [],
        })
      }
    )
  }

  /**
   * 提交載具綁定
   */
  submitBinding = () => {
    const { selectedCard, cardType, bigPlatformToken, bigPlatformBan } =
      this.state

    if (!selectedCard) {
      return notification.warning({
        message: __('請選擇會員卡', 'cec-plugin-stores'),
      })
    }

    Modal.confirm({
      title: __('確認載具綁定', 'cec-plugin-stores'),
      content: __(
        '確定要將此會員卡綁定至財政部電子發票平台嗎?',
        'cec-plugin-stores'
      ),
      okText: __('確定綁定', 'cec-plugin-stores'),
      cancelText: __('取消', 'cec-plugin-stores'),
      onOk: () => {
        this.performBinding()
      },
    })
  }

  /**
   * 執行綁定操作
   */
  performBinding = () => {
    const { selectedCard, cardType, bigPlatformToken } = this.state

    this.setState({ isSubmitting: true })

    // 呼叫後端 API 取得大平台表單資料
    whttp.post(
      API_HOST + `/api/account/cc/getBigPlatformCarrierFormData`,
      {
        card: selectedCard,
        type: cardType,
        token: bigPlatformToken,
      },
      (state, res) => {
        this.setState({ isSubmitting: false })

        const {
          code = 100,
          reason = __('發生錯誤', 'cec-plugin-stores'),
          data = {},
        } = res

        console.log('取得大平台表單資料:', { state, code, reason, data })

        if (state === false) {
          return Modal.error({
            title: __('綁定失敗', 'cec-plugin-stores'),
            content: __('無法連接伺服器，請稍後再試', 'cec-plugin-stores'),
          })
        }

        if (code !== 200) {
          return Modal.error({
            title: __('綁定失敗', 'cec-plugin-stores'),
            content: reason,
          })
        }

        // 取得表單資料後，發送 POST 給財政部
        this.submitToBigPlatform(data)
      }
    )
  }

  /**
   * 提交表單至財政部大平台
   */
  submitToBigPlatform = (formData) => {
    const { url, card_ban, card_no1, card_no2, card_type, token, signature } =
      formData

    if (!url) {
      return Modal.error({
        title: __('綁定失敗', 'cec-plugin-stores'),
        content: __('無法取得財政部平台網址', 'cec-plugin-stores'),
      })
    }

    console.log('準備提交至財政部大平台:', formData)

    // 清除 storage 中的大平台相關資料
    AppHelper.removeLocalStorage('big-platform-token')
    AppHelper.removeLocalStorage('big-platform-ban')
    AppHelper.removeLocalStorage('from-big-platform')
    AppHelper.removeLocalStorage('to-href')

    // 顯示確認彈窗
    Modal.confirm({
      title: __('即將前往財政部電子發票平台', 'cec-plugin-stores'),
      content: __(
        '您將離開本網站，前往財政部電子發票平台完成載具綁定',
        'cec-plugin-stores'
      ),
      cancelText: __('取消', 'cec-plugin-stores'),
      okText: __('前往財政部平台', 'cec-plugin-stores'),
      onCancel: null,
      onOk: () => {
        // 建立表單並提交
        const form = document.createElement('form')
        form.setAttribute('method', 'post')
        form.setAttribute('action', url)
        form.setAttribute('target', '_self')

        // 加入表單參數
        const params = {
          card_ban: card_ban,
          card_no1: card_no1,
          card_no2: card_no2,
          card_type: card_type,
          token: token,
          signature: signature,
        }

        _.forEach(params, (value, key) => {
          if (value !== undefined && value !== null) {
            console.log(`表單參數: ${key}=${value}`)
            const input = document.createElement('input')
            input.type = 'hidden'
            input.name = key
            input.value = value
            form.appendChild(input)
          }
        })

        document.body.appendChild(form)
        form.submit()
      },
    })
  }

  /**
   * 處理綁定成功
   */
  handleBindingSuccess = (data) => {
    // 此方法已不再使用，因為綁定流程改為直接導向財政部平台
    // 保留此方法以防未來需要
    console.log('綁定成功（舊流程）:', data)
  }

  /**
   * 顯示錯誤並導向首頁
   */
  showErrorAndRedirect = (message) => {
    Modal.error({
      title: __('錯誤', 'cec-plugin-stores'),
      content: message,
      onOk: () => {
        // 清除相關 storage
        AppHelper.removeLocalStorage('big-platform-token')
        AppHelper.removeLocalStorage('big-platform-ban')
        AppHelper.removeLocalStorage('from-big-platform')
        window.location.href = VC_CONFIG.INDEX_URL
      },
    })
  }

  /**
   * 取消綁定流程
   */
  cancelBinding = () => {
    Modal.confirm({
      title: __('確認取消', 'cec-plugin-stores'),
      content: __('確定要取消載具綁定流程嗎?', 'cec-plugin-stores'),
      okText: __('確定取消', 'cec-plugin-stores'),
      cancelText: __('繼續綁定', 'cec-plugin-stores'),
      onOk: () => {
        // 清除相關 storage
        AppHelper.removeLocalStorage('big-platform-token')
        AppHelper.removeLocalStorage('big-platform-ban')
        AppHelper.removeLocalStorage('from-big-platform')
        AppHelper.removeLocalStorage('to-href')

        notification.info({
          message: __('已取消綁定', 'cec-plugin-stores'),
          duration: 1,
        })

        setTimeout(() => {
          window.location.href = `${VC_CONFIG.INDEX_URL}/profile`
        }, 1000)
      },
    })
  }

  render() {
    const {
      isLoading,
      isSubmitting,
      cardOptions,
      selectedCard,
      memberInfo,
    } = this.state

    if (isLoading) {
      return (
        <div
          style={{ height: '350px' }}
          className='jumbotron d-flex align-items-center'>
          <div className='container text-center'>
            <Spin size='large' />
            <h4 className='mt-4'>
              {__('載入中...', 'cec-plugin-stores')}
            </h4>
          </div>
        </div>
      )
    }

    return (
      <main className='bg-light'>
        <div className='container'>
          <section className='pt-5 pb-5'>
            {/* 麵包屑導航 */}
            <div className='breadcrumb-wrap mb-4'>
              <nav aria-label='breadcrumb'>
                <ol className='breadcrumb'>
                  <li className='breadcrumb-item'>
                    <a href={`${VC_CONFIG.INDEX_URL}/`}>
                      {__('首頁', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='breadcrumb-item'>
                    <a href={`${VC_CONFIG.INDEX_URL}/profile`}>
                      {__('會員中心', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li
                    className='breadcrumb-item active'
                    aria-current='page'>
                    {__('載具綁定', 'cec-plugin-stores')}
                  </li>
                </ol>
              </nav>
            </div>

            {/* 標題 */}
            <h3 className='h4 text-navy mb-4'>
              {__('財政部電子發票平台 - 載具綁定', 'cec-plugin-stores')}
            </h3>

            {/* 提示訊息 */}
            <Alert
              message={__('請選擇要綁定的會員卡', 'cec-plugin-stores')}
              description={__(
                '選擇會員卡後，您的電子發票將會自動歸戶至財政部電子發票平台',
                'cec-plugin-stores',
              )}
              type='info'
              showIcon
              className='mb-4'
            />

            {/* 綁定表單 */}
            <Card className='shadow-sm'>
              <div className='row'>
                <div className='col-md-8 mx-auto'>
                  <Form layout='vertical'>
                    <Form.Item
                      label={__('選擇會員卡', 'cec-plugin-stores')}
                      required>
                      <Select
                        size='large'
                        placeholder={__(
                          '請選擇要綁定的會員卡',
                          'cec-plugin-stores',
                        )}
                        value={selectedCard || undefined}
                        onChange={(value) => {
                          const [cardId, cardType] = value.split('_')
                          this.setState({
                            selectedCard: cardId,
                            cardType: cardType,
                          })
                        }}>
                        {_.map(cardOptions, (item) => (
                          <Option
                            key={item.id}
                            value={`${item.id}_${item.type}`}>
                            {item.id}{' '}
                            {item.typeName ? `(${item.typeName})` : ''}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>

                    {/* 會員資訊顯示 */}
                    {memberInfo && (
                      <div className='mb-4 p-3 bg-light rounded'>
                        <h6 className='text-navy mb-2'>
                          {__('會員資訊', 'cec-plugin-stores')}
                        </h6>
                        <p className='mb-1'>
                          <strong>
                            {__('會員卡號：', 'cec-plugin-stores')}
                          </strong>
                          {memberInfo.member_profile_linkcode}
                        </p>
                        <p className='mb-0'>
                          <strong>
                            {__('會員等級：', 'cec-plugin-stores')}
                          </strong>
                          {memberInfo.member_profile_isvip == 1
                            ? 'VIP'
                            : __('一般會員', 'cec-plugin-stores')}
                          {memberInfo.member_profile_isopen == 1 &&
                            ' + OPENPOINT'}
                        </p>
                      </div>
                    )}

                    {/* 按鈕區 */}
                    <div className='row'>
                      <div className='col-6'>
                        <Button
                          size='large'
                          block
                          onClick={this.cancelBinding}
                          disabled={isSubmitting}>
                          {__('取消', 'cec-plugin-stores')}
                        </Button>
                      </div>
                      <div className='col-6'>
                        <Button
                          type='primary'
                          size='large'
                          block
                          onClick={this.submitBinding}
                          loading={isSubmitting}
                          disabled={!selectedCard}>
                          {__('確認綁定', 'cec-plugin-stores')}
                        </Button>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </Card>

            {/* 注意事項 */}
            <div className='mt-4'>
              <Card className='shadow-sm'>
                <h6 className='text-navy mb-3'>
                  {__('注意事項', 'cec-plugin-stores')}
                </h6>
                <ul className='text-muted mb-0'>
                  <li>
                    {__(
                      '綁定後，您在的消費電子發票將自動歸戶至財政部電子發票平台',
                      'cec-plugin-stores',
                    )}
                  </li>
                  <li>
                    {__(
                      '請確認選擇的會員卡號正確，綁定後如需變更請聯繫客服',
                      'cec-plugin-stores',
                    )}
                  </li>
                  <li>
                    {__(
                      '若您已在小平台完成歸戶，此次綁定將會更新您的歸戶資訊',
                      'cec-plugin-stores',
                    )}
                  </li>
                </ul>
              </Card>
            </div>
          </section>
        </div>
      </main>
    )
  }
}

// 編輯器組件
export class UserCarrierBindingEditor extends Component {
  render() {
    return (
      <div className='vu-blocks-editor'>
        <h2>載具綁定頁面</h2>
        <p>用戶選擇會員卡進行大平台載具綁定</p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/blocks/users/user-carrier-binding.js